// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg width=%2760%27 height=%2760%27 viewBox=%270 0 60 60%27 xmlns=%27http://www.w3.org/2000/svg%27%3E%3Cg fill=%27none%27 fill-rule=%27evenodd%27%3E%3Cg fill=%27%23dcca98%27 fill-opacity=%270.05%27%3E%3Cpath d=%27M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z%27/%3E%3C/g%3E%3C/g%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Login.css */
#login {
    padding: 100px 0;
    background: linear-gradient(135deg, #0a2e2e 0%, #114040 50%, #0f2f2f 100%);
    position: relative;
    overflow: hidden;
    min-height: 100vh;
    display: flex;
    align-items: center;
  }
  
  /* Add subtle pattern overlay */
  #login::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    opacity: 0.8;
    z-index: 1;
    pointer-events: none;
  }
  
  .login-container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 2;
    width: 100%;
    display: flex;
    justify-content: center;
  }
  
  .login-card-container {
    width: 100%;
    max-width: 560px;
    margin: 0 auto;
    opacity: 0;
    transform: translateY(40px);
    animation: fadeInUp 0.8s forwards;
  }
  
  @keyframes fadeInUp {
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
  
  .login-form-wrapper {
    background-color: #fffbe6;
    border-radius: 16px;
    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
    overflow: hidden;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
  }
  
  .login-form-wrapper:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);
  }
  
  .login-section-title {
    padding: 25px 30px 0;
    position: relative;
  }
  
  .login-section-title h2 {
    font-size: 2.2rem;
    font-weight: 700;
    margin-bottom: 10px;
    color: #114040;
    text-align: center;
    letter-spacing: 1px;
    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    position: relative;
    display: inline-block;
  }
  
  .login-section-title h2::after {
    content: '';
    position: absolute;
    width: 60px;
    height: 3px;
    background: linear-gradient(90deg, #114040, #0f2f2f);
    bottom: -8px;
    left: 50%;
    transform: translateX(-50%);
  }
  
  .login-error-message {
    color: #e74c3c;
    text-align: center;
    margin: 15px 0 0;
    font-size: 0.9rem;
    font-weight: 500;
  }
  
  .login-form {
    padding: 20px 30px 30px;
  }
  
  .login-input-group {
    margin-bottom: 20px;
  }
  
  .login-input-group label {
    display: block;
    margin-bottom: 8px;
    color: #114040;
    font-weight: 500;
    font-size: 0.95rem;
  }
  
  .login-input-group input {
    width: 100%;
    padding: 12px 15px;
    border: 1px solid rgba(17, 64, 64, 0.2);
    border-radius: 8px;
    font-size: 1rem;
    background-color: white;
    transition: border 0.3s ease, box-shadow 0.3s ease;
  }
  
  .login-input-group input:focus {
    outline: none;
    border-color: #114040;
    box-shadow: 0 0 0 2px rgba(17, 64, 64, 0.1);
  }
  
  .login-button {
    width: 100%;
    padding: 14px;
    background-color: #114040;
    color: #dcca98;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 600;
    letter-spacing: 0.5px;
    transition: all 0.3s ease;
    margin-bottom: 15px;
    position: relative;
    overflow: hidden;
  }
  
  .login-button::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);
    transition: left 0.7s ease;
  }
  
  .login-button:hover {
    background-color: #0a2e2e;
    transform: translateY(-2px);
    box-shadow: 0 5px 15px rgba(10, 46, 46, 0.2);
  }
  
  .login-button:hover::before {
    left: 100%;
  }
  
  .login-button:disabled {
    background-color: #6a8d8d;
    cursor: not-allowed;
    transform: none;
  }
  
  .login-logout-button {
    width: 100%;
    padding: 12px;
    background-color: rgba(17, 64, 64, 0.1);
    color: #114040;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.9rem;
    transition: all 0.3s ease;
    margin-bottom: 15px;
  }
  
  .login-logout-button:hover {
    background-color: rgba(17, 64, 64, 0.2);
  }
  
  .login-form-links {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    font-size: 0.9rem;
  }
  
  .login-form-toggle {
    color: #114040;
    cursor: pointer;
    transition: color 0.3s ease;
    font-size: 0.9rem;
    text-align: center;
    margin-bottom: 15px;
  }
  
  .login-form-toggle:hover {
    color: #0a2e2e;
    text-decoration: underline;
  }
  
  .login-forgot-link, .login-back-link {
    color: #114040;
  }
  
  .login-account-toggle {
    color: #114040;
  }
  
  .login-google-login-button {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    padding: 12px;
    background-color: white;
    color: #333;
    border: 1px solid rgba(17, 64, 64, 0.15);
    border-radius: 8px;
    cursor: pointer;
    font-size: 0.95rem;
    font-weight: 500;
    transition: all 0.3s ease;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);
  }
  
  .login-google-login-button:hover {
    background-color: #f9f9f9;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }
  
  .login-google-logo {
    height: 20px;
    width: 20px;
    margin-right: 10px;
  }
  
  /* Responsive styles */
  @media (max-width: 768px) {
    #login {
      padding: 60px 0;
    }
    
    .login-card-container {
      max-width: 90%;
    }
    
    .login-section-title h2 {
      font-size: 1.8rem;
    }
    
    .login-form-links {
      flex-direction: column;
      align-items: center;
      gap: 10px;
    }
  }
  
  @media (max-width: 480px) {
    .login-form {
      padding: 15px 20px 25px;
    }
    
    .login-section-title {
      padding: 20px 20px 0;
    }
    
    .login-section-title h2 {
      font-size: 1.6rem;
    }
    
    .login-input-group input,
    .login-button,
    .login-logout-button,
    .login-google-login-button {
      padding: 10px;
    }
  }
  
  /* Touch device optimizations */
  @media (hover: none) {
    .login-form-wrapper:hover {
      transform: none;
      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);
    }
    
    .login-button:hover {
      background-color: #114040;
      transform: none;
      box-shadow: none;
    }
  }
  
  /* iOS-specific fixes */
  @supports (-webkit-touch-callout: none) {
    #login {
      -webkit-backface-visibility: hidden;
      -webkit-perspective: 1000;
    }
    
    .login-card-container {
      -webkit-transform: translate3d(0, 40px, 0);
    }
    
    @keyframes fadeInUp {
      to {
        opacity: 1;
        -webkit-transform: translate3d(0, 0, 0);
      }
    }
  }`, "",{"version":3,"sources":["webpack://./src/login/Login.css"],"names":[],"mappings":"AAAA,cAAc;AACd;IACI,gBAAgB;IAChB,0EAA0E;IAC1E,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,aAAa;IACb,mBAAmB;EACrB;;EAEA,+BAA+B;EAC/B;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,yDAAoY;IACpY,YAAY;IACZ,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,2BAA2B;IAC3B,iCAAiC;EACnC;;EAEA;IACE;MACE,UAAU;MACV,wBAAwB;IAC1B;EACF;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,2CAA2C;IAC3C,gBAAgB;IAChB,qDAAqD;EACvD;;EAEA;IACE,2BAA2B;IAC3B,0CAA0C;EAC5C;;EAEA;IACE,oBAAoB;IACpB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,yCAAyC;IACzC,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,oDAAoD;IACpD,YAAY;IACZ,SAAS;IACT,2BAA2B;EAC7B;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kDAAkD;EACpD;;EAEA;IACE,aAAa;IACb,qBAAqB;IACrB,2CAA2C;EAC7C;;EAEA;IACE,WAAW;IACX,aAAa;IACb,yBAAyB;IACzB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,WAAW;IACX,YAAY;IACZ,sFAAsF;IACtF,0BAA0B;EAC5B;;EAEA;IACE,yBAAyB;IACzB,2BAA2B;IAC3B,4CAA4C;EAC9C;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;IACnB,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,uCAAuC;IACvC,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,mBAAmB;EACrB;;EAEA;IACE,uCAAuC;EACzC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,iBAAiB;EACnB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,0BAA0B;EAC5B;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,WAAW;IACX,wCAAwC;IACxC,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,yCAAyC;EAC3C;;EAEA;IACE,yBAAyB;IACzB,wCAAwC;EAC1C;;EAEA;IACE,YAAY;IACZ,WAAW;IACX,kBAAkB;EACpB;;EAEA,sBAAsB;EACtB;IACE;MACE,eAAe;IACjB;;IAEA;MACE,cAAc;IAChB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,sBAAsB;MACtB,mBAAmB;MACnB,SAAS;IACX;EACF;;EAEA;IACE;MACE,uBAAuB;IACzB;;IAEA;MACE,oBAAoB;IACtB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;;;;MAIE,aAAa;IACf;EACF;;EAEA,+BAA+B;EAC/B;IACE;MACE,eAAe;MACf,2CAA2C;IAC7C;;IAEA;MACE,yBAAyB;MACzB,eAAe;MACf,gBAAgB;IAClB;EACF;;EAEA,uBAAuB;EACvB;IACE;MACE,mCAAmC;MACnC,yBAAyB;IAC3B;;IAEA;MACE,0CAA0C;IAC5C;;IAEA;MACE;QACE,UAAU;QACV,uCAAuC;MACzC;IACF;EACF","sourcesContent":["/* Login.css */\n#login {\n    padding: 100px 0;\n    background: linear-gradient(135deg, #0a2e2e 0%, #114040 50%, #0f2f2f 100%);\n    position: relative;\n    overflow: hidden;\n    min-height: 100vh;\n    display: flex;\n    align-items: center;\n  }\n  \n  /* Add subtle pattern overlay */\n  #login::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-image: url(\"data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23dcca98' fill-opacity='0.05'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E\");\n    opacity: 0.8;\n    z-index: 1;\n    pointer-events: none;\n  }\n  \n  .login-container {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 2;\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  \n  .login-card-container {\n    width: 100%;\n    max-width: 560px;\n    margin: 0 auto;\n    opacity: 0;\n    transform: translateY(40px);\n    animation: fadeInUp 0.8s forwards;\n  }\n  \n  @keyframes fadeInUp {\n    to {\n      opacity: 1;\n      transform: translateY(0);\n    }\n  }\n  \n  .login-form-wrapper {\n    background-color: #fffbe6;\n    border-radius: 16px;\n    box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n    overflow: hidden;\n    transition: transform 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .login-form-wrapper:hover {\n    transform: translateY(-5px);\n    box-shadow: 0 15px 35px rgba(0, 0, 0, 0.3);\n  }\n  \n  .login-section-title {\n    padding: 25px 30px 0;\n    position: relative;\n  }\n  \n  .login-section-title h2 {\n    font-size: 2.2rem;\n    font-weight: 700;\n    margin-bottom: 10px;\n    color: #114040;\n    text-align: center;\n    letter-spacing: 1px;\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\n    position: relative;\n    display: inline-block;\n  }\n  \n  .login-section-title h2::after {\n    content: '';\n    position: absolute;\n    width: 60px;\n    height: 3px;\n    background: linear-gradient(90deg, #114040, #0f2f2f);\n    bottom: -8px;\n    left: 50%;\n    transform: translateX(-50%);\n  }\n  \n  .login-error-message {\n    color: #e74c3c;\n    text-align: center;\n    margin: 15px 0 0;\n    font-size: 0.9rem;\n    font-weight: 500;\n  }\n  \n  .login-form {\n    padding: 20px 30px 30px;\n  }\n  \n  .login-input-group {\n    margin-bottom: 20px;\n  }\n  \n  .login-input-group label {\n    display: block;\n    margin-bottom: 8px;\n    color: #114040;\n    font-weight: 500;\n    font-size: 0.95rem;\n  }\n  \n  .login-input-group input {\n    width: 100%;\n    padding: 12px 15px;\n    border: 1px solid rgba(17, 64, 64, 0.2);\n    border-radius: 8px;\n    font-size: 1rem;\n    background-color: white;\n    transition: border 0.3s ease, box-shadow 0.3s ease;\n  }\n  \n  .login-input-group input:focus {\n    outline: none;\n    border-color: #114040;\n    box-shadow: 0 0 0 2px rgba(17, 64, 64, 0.1);\n  }\n  \n  .login-button {\n    width: 100%;\n    padding: 14px;\n    background-color: #114040;\n    color: #dcca98;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: 600;\n    letter-spacing: 0.5px;\n    transition: all 0.3s ease;\n    margin-bottom: 15px;\n    position: relative;\n    overflow: hidden;\n  }\n  \n  .login-button::before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: -100%;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.1), transparent);\n    transition: left 0.7s ease;\n  }\n  \n  .login-button:hover {\n    background-color: #0a2e2e;\n    transform: translateY(-2px);\n    box-shadow: 0 5px 15px rgba(10, 46, 46, 0.2);\n  }\n  \n  .login-button:hover::before {\n    left: 100%;\n  }\n  \n  .login-button:disabled {\n    background-color: #6a8d8d;\n    cursor: not-allowed;\n    transform: none;\n  }\n  \n  .login-logout-button {\n    width: 100%;\n    padding: 12px;\n    background-color: rgba(17, 64, 64, 0.1);\n    color: #114040;\n    border: none;\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.9rem;\n    transition: all 0.3s ease;\n    margin-bottom: 15px;\n  }\n  \n  .login-logout-button:hover {\n    background-color: rgba(17, 64, 64, 0.2);\n  }\n  \n  .login-form-links {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 20px;\n    font-size: 0.9rem;\n  }\n  \n  .login-form-toggle {\n    color: #114040;\n    cursor: pointer;\n    transition: color 0.3s ease;\n    font-size: 0.9rem;\n    text-align: center;\n    margin-bottom: 15px;\n  }\n  \n  .login-form-toggle:hover {\n    color: #0a2e2e;\n    text-decoration: underline;\n  }\n  \n  .login-forgot-link, .login-back-link {\n    color: #114040;\n  }\n  \n  .login-account-toggle {\n    color: #114040;\n  }\n  \n  .login-google-login-button {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    width: 100%;\n    padding: 12px;\n    background-color: white;\n    color: #333;\n    border: 1px solid rgba(17, 64, 64, 0.15);\n    border-radius: 8px;\n    cursor: pointer;\n    font-size: 0.95rem;\n    font-weight: 500;\n    transition: all 0.3s ease;\n    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.05);\n  }\n  \n  .login-google-login-button:hover {\n    background-color: #f9f9f9;\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n  }\n  \n  .login-google-logo {\n    height: 20px;\n    width: 20px;\n    margin-right: 10px;\n  }\n  \n  /* Responsive styles */\n  @media (max-width: 768px) {\n    #login {\n      padding: 60px 0;\n    }\n    \n    .login-card-container {\n      max-width: 90%;\n    }\n    \n    .login-section-title h2 {\n      font-size: 1.8rem;\n    }\n    \n    .login-form-links {\n      flex-direction: column;\n      align-items: center;\n      gap: 10px;\n    }\n  }\n  \n  @media (max-width: 480px) {\n    .login-form {\n      padding: 15px 20px 25px;\n    }\n    \n    .login-section-title {\n      padding: 20px 20px 0;\n    }\n    \n    .login-section-title h2 {\n      font-size: 1.6rem;\n    }\n    \n    .login-input-group input,\n    .login-button,\n    .login-logout-button,\n    .login-google-login-button {\n      padding: 10px;\n    }\n  }\n  \n  /* Touch device optimizations */\n  @media (hover: none) {\n    .login-form-wrapper:hover {\n      transform: none;\n      box-shadow: 0 12px 30px rgba(0, 0, 0, 0.25);\n    }\n    \n    .login-button:hover {\n      background-color: #114040;\n      transform: none;\n      box-shadow: none;\n    }\n  }\n  \n  /* iOS-specific fixes */\n  @supports (-webkit-touch-callout: none) {\n    #login {\n      -webkit-backface-visibility: hidden;\n      -webkit-perspective: 1000;\n    }\n    \n    .login-card-container {\n      -webkit-transform: translate3d(0, 40px, 0);\n    }\n    \n    @keyframes fadeInUp {\n      to {\n        opacity: 1;\n        -webkit-transform: translate3d(0, 0, 0);\n      }\n    }\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
